import React, { useState, useEffect } from 'react';
import { Button, Input, message, Select, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import BaseDeleteFooter from '../../../components/footer/base_delete';
import { restApi } from '../../../apis';
import CenterPofileDetail from './center_profile_detail';
import dayjs from 'dayjs';

const LOGIN_STATUS_OPTIONS = [
  { value: 0, label: '로그아웃' },
  { value: 1, label: '로그인중' },
  { value: 2, label: '중복로그인 허용' },
];

const LOGIN_STATUS_LABELS = {
  0: '로그아웃',
  1: '로그인중',
  2: '중복로그인 허용',
};

const CenterPofile = (props) => {
  const { centerId, setCenterName, setLoading, loading, ...rest } = props;
  const [messageApi, contextHolder] = message.useMessage();
  const [isRead, setRead] = useState(false);
  const [data, setData] = useState({});
  const [optPlans, setOptPlans] = useState([]);
  const [loginStatusLoading, setLoginStatusLoading] = useState(false);

  useEffect(() => {
    // 로딩
    setLoading(true);
    // 데이터 가져오기
    (async (args) => {
      let response = await restApi.get(`/admin/plan`);
      const options = response?.data?.payload?.planList || [
        {
          value: null,
          label: `구독한 플랜(프로모션) 없음`,
        },
      ];
      //---------
      response = await restApi.get(`/admin/center/${centerId}`);
      const payload = response?.data?.payload;
      if (payload) {
        // console.log('--->', payload);
        setOptPlans(() => {
          let resOptions = [];

          let i = 0;
          for (; i < options?.length; i++) {
            const item = options[i];
            resOptions.push({
              value: item.id,
              label: item.name,
            });
          }
          resOptions.push({
            value: null,
            label: `구독한 플랜(프로모션) 없음`,
          });
          return resOptions;
        });
        setCenterName(payload?.center?.center_name);
        setData && setData(payload?.center);
      }
      setLoading(false);
    })();

    setTimeout(() => {
      setLoading(false);
    }, 5000);
  }, []);

  const saveData = async () => {
    // 로딩
    setLoading(true);
    const response = await restApi
      .patch(`/admin/center/${centerId}`, {
        center_name: data?.center_name,
        center_phone: data?.center_phone,
        center_identifyCode: data?.center_identifyCode,
        center_password: data?.center_password,
        center_createdAt: dayjs(data?.center_createdAt).format(
          'YYYY-MM-DD 00:00:00'
        ),
        center_ipAddress: data?.center_ipAddress,
        center_comment: data?.center_comment,
        contract_id: data?.contract_id,
        contract_autoPayment: data?.contract_autoPayment,
        contract_paymentMethod: data?.contract_paymentMethod,
        contract_paymentAmount: data?.contract_paymentAmount,
        contract_paidDate: data?.contract_paidDate
          ? dayjs(data.contract_paidDate).format('YYYY-MM-DD HH:mm:ss')
          : null,
        contract_startDate: data?.contract_startDate
          ? dayjs(data.contract_startDate).format('YYYY-MM-DD HH:mm:ss')
          : null,
        contract_endDate: data?.contract_endDate
          ? dayjs(data.contract_endDate).format('YYYY-MM-DD HH:mm:ss')
          : null,
        account_id: data?.account_id,
        account_name: data?.account_name,
        account_phone: data?.account_phone,
        account_email: data?.account_email,
        plan_id: data?.plan_id,
        photo_key: data?.photo_key,
        photo_path: data?.photo_path,
        photo_ext: data?.photo_ext,
      })
      .then((v) => {
        setLoading(false);
        if(v?.data.message == 'ok') { 
          messageApi.info('수정에 성공했습니다.')
        } else {
          messageApi.error(v?.data.message)
        }
        return v?.data;
      });
    // message_info(
    //   (response?.message?.length && '저장에 성공하였습니다.') ||
    //     '저장하는데 실패하였습니다.'
    // );
    return;
  };

  const onDeleted = async () => {
    setLoading(true);
    const response = await restApi
      .delete(`/admin/center/${centerId}`, {
        params: { depth: null },
      })
      .then((v) => {
        setLoading(false);
        return v && v.data && v.data.payload;
      });
      messageApi.info(
      (response && response.message) || '삭제하는데 실패하였습니다.'
    );
    return;
  };

  // 로그인 상태 변경 실행
  const executeLoginStatusChange = async (newStatus) => {
    setLoginStatusLoading(true);
    try {
      const response = await restApi.patch(`/admin/account/${data.account_id}/login-status`, {
        loginStatus: newStatus,
      });
      
      if (response?.data?.message === 'OK') {
        setData((prev) => ({ ...prev, account_loginStatus: newStatus }));
        messageApi.success('로그인 상태가 변경되었습니다.');
      } else {
        messageApi.error(response?.data?.error?.message || '로그인 상태 변경에 실패했습니다.');
      }
    } catch (err) {
      messageApi.error('로그인 상태 변경에 실패했습니다.');
    } finally {
      setLoginStatusLoading(false);
    }
  };

  // 로그인 상태 변경 핸들러 (확인 모달 표시)
  const handleLoginStatusChange = (newStatus) => {
    if (!data.account_id) return;
    
    const currentLabel = LOGIN_STATUS_LABELS[data.account_loginStatus] || '알 수 없음';
    const newLabel = LOGIN_STATUS_LABELS[newStatus] || '알 수 없음';
    
    Modal.confirm({
      title: '로그인 상태 변경',
      icon: <ExclamationCircleOutlined />,
      content: (
        <div>
          <p><strong>{data.center_name}</strong> 센터의 로그인 상태를 변경하시겠습니까?</p>
          <p style={{ marginTop: 12, color: '#666' }}>
            <span style={{ color: '#999' }}>{currentLabel}</span>
            {' → '}
            <span style={{ color: '#7367F0', fontWeight: 600 }}>{newLabel}</span>
          </p>
          {newStatus === 0 && (
            <p style={{ marginTop: 8, color: '#ff4d4f', fontSize: 12 }}>
              ⚠️ 로그아웃 처리 시 현재 기기 정보와 리프레시 토큰이 초기화됩니다.
            </p>
          )}
        </div>
      ),
      okText: '변경',
      cancelText: '취소',
      onOk: () => executeLoginStatusChange(newStatus),
    });
  };

  return (
    <>
      <div style={{ ...styles.container }}>
        {contextHolder}
        <div style={{ ...styles.header }}>
          <div style={{ ...styles.title }}>{`센터프로필`}</div>
          <Button
            style={{ ...styles.botton_update }}
            onClick={(e) => {
              saveData();
            }}
          >{`프로필 수정하기`}</Button>
        </div>
        {/* ---------------------------------------------------------------------------------------------------- */}
        <CenterPofileDetail
          data={data}
          setData={setData}
          isRead={isRead}
          setRead={setRead}
          optPlans={optPlans}
          {...props}
        />
        {/* ---------------------------------------------------------------------------------------------------- */}
      </div>
      <div style={{ marginTop: 24 }} />
      {/* ---------------------------------------------------------------------------------------------------- */}
      {/* 로그인 상태 변경 섹션 */}
      <div style={{ ...styles.container }}>
        <div style={{ ...styles.header }}>
          <div style={{ ...styles.title }}>{`로그인 상태 관리`}</div>
        </div>
        <div style={{ ...styles.row, padding: '2rem 2.4rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1.6rem' }}>
            <span style={{ fontWeight: 500, fontSize: '1.4rem', color: '#4B465C' }}>
              현재 로그인 상태:
            </span>
            <Select
              style={{ width: 200 }}
              value={data.account_loginStatus}
              onChange={handleLoginStatusChange}
              loading={loginStatusLoading}
              disabled={loginStatusLoading || !data.account_id}
              options={LOGIN_STATUS_OPTIONS}
              placeholder="상태 선택"
            />
          </div>
        </div>
      </div>
      <div style={{ marginTop: 24 }} />
      {/* ---------------------------------------------------------------------------------------------------- */}
      <BaseDeleteFooter
        id={centerId}
        title={`센터 계정 삭제`}
        boxTitle={`해당 센터 계정을 삭제하시겠습니까?`}
        boxContents={`삭제한 계정에 포함된 데이터(시퀀스/템포/강의)는 밸런스피터 DB로 종속되며, 한번 삭제한 센터 계정은 다시 복구할 수 업습니다. 정말 삭제하시겠습니까?`}
        buttonTitle={`센터 계정 삭제`}
        onDeleted={onDeleted}
      />
      {/* ---------------------------------------------------------------------------------------------------- */}
    </>
  );
};

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'flex-start',
    background: '#FFF',
    boxShadow: '0px 4px 18px rgba(75, 70, 92, 0.1)',
    borderRadius: 6,
    padding: 0,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    /*
    fontWeight: 600,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
    letterSpacing: 1,
    textTransform: 'uppercase',
		*/
  },

  header: {
    display: 'flex',
    width: '100%',
    height: '6.8rem',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #DBDADE',
    padding: '0rem 2.4rem 0rem 2.4rem',
    background: '#FFFFFF',
  },
  title: {
    display: 'flex',
    width: '50rem',
    // flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',

    fontWeight: 600,
    fontSize: '1.8rem',
    lineHeight: '2.4rem',
    // letterSpacing: 1,
    // textTransform: 'uppercase',
  },
  col_title: {
    display: 'flex',
    // flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    //font
    fontWeight: 400,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
  },
  botton_update: {
    display: 'flex',
    width: '14.3rem',
    height: '3.8rem',
    alignItems: 'center',
    justifyContent: 'center',

    border: 0,
    background: `linear-gradient(72.47deg, #7367F0 22.16%, rgba(115, 103, 240, 0.7) 76.47%)`,
    // ...item.style,
    color: '#FFF',
  },
  row: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0rem 2.4rem 0rem 2.4rem',
    background: '#FFFFFF',
  },
  column: {
    display: 'flex',
    // height: '100%',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0rem 0.9rem 0rem 0.9rem',
    background: '#FFFFFF',
  },
};
export default CenterPofile;
